import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "query",
    "option",
    "checkbox",
    "empty",
    "count"
  ]

  connect() {
    this.refresh()
  }

  filter() {
    this.refresh()
  }

  toggle() {
    this.refresh()
  }

  refresh() {
    const query = this.queryValue()
    let visibleCount = 0

    this.optionTargets.forEach((option) => {
      const checkbox = option.querySelector("input[type='checkbox']")
      const isSelected = checkbox?.checked === true
      const matches = query === "" || this.normalize(option.dataset.sportName || "").includes(query)
      const shouldShow = matches || isSelected

      option.classList.toggle("d-none", !shouldShow)
      option.querySelector("label.wizard-choice")?.classList.toggle("is-selected", isSelected)

      if (shouldShow) visibleCount += 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("d-none", visibleCount > 0)
    }

    if (this.hasCountTarget) {
      const selectedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length
      this.countTarget.textContent = `${selectedCount} selecionado(s)`
    }
  }

  queryValue() {
    return this.normalize(this.hasQueryTarget ? this.queryTarget.value : "")
  }

  normalize(value) {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim()
  }
}
